import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { ConfirmDialog, Toast } from "components";
import Provider from "provider";
import { useSelector } from "react-redux";
import { selectGameId } from "features/gamestate/gameStateSlice";
import logging from "utils/logging";

const log = logging.getLogger("Game Settings");

const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const ResetGameButton = () => {
  const gameId = useSelector(selectGameId);

  const [resetting, setResetting] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const resetGame = async () => {
    setResetting(true);
    setConfirmOpen(false);
    const result = await Provider.resetGame(gameId);
    log.debug("reset game result: ", result);
    setResetting(false);
    setToastMessage("Game has been reset!");
    setToastOpen(true);
  };

  return (
    <React.Fragment>
      <StyledButton
        size="large"
        variant="contained"
        onClick={() => setConfirmOpen(true)}
        color="secondary"
        disabled={resetting}
      >
        Reset Game
      </StyledButton>

      <ConfirmDialog
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={resetGame}
        confirmLabel="Reset Game"
        loading={resetting}
        message={
          <>
            Are you sure you want to reset this game? This will delete all
            participants, scores, and reset the game to the beginning.
            <br />
            <br />
            The questions will remain unchanged.
          </>
        }
      />

      <Toast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message={toastMessage}
        severity="success"
      />
    </React.Fragment>
  );
};

export default ResetGameButton;
